<div class="height-100 p-t-5 p-b-5 p-r-9 p-l-9">
    @if (content) {
    <div class="pos-absolute top-2 right-1 z-3 p-a-3 right">
        <button type="button"
                (click)="close()"
                [attr.aria-label]="'Close' | translate">
            <i class="icon-close col-12"
               aria-hidden="true"></i>
        </button>
    </div>

    <div class="flex flex-middle">
        @if (content.image) {
        <img [dfImage]="content.image"
             [width]="48"
             [height]="48"
             style="border-radius: 12px; object-fit: cover; min-width: 48px;"
             class="m-r-2" />
        }

        <div>
            <div class="flex flex-bottom">
                <div class="m-r-2"
                     style="padding-bottom: 2px;">
                    <img [dfImage]="content.logo"
                         [width]="82"
                         [height]="18"
                         [loaderParams]="{fitIn:true, fillColor:'transparent'}" />
                </div>
                @if (content.reviewsNumber) {
                <rating [value]="content.reviewsNumber"></rating>
                }
            </div>
            <p class="p3 m-t-1"
               *iCms="'copy' of content; content: 'html'"></p>
        </div>
    </div>

    <div class="w-12 m-t">
        @if (appLink) {
        <a class="button w-12"
           [href]="appLink || ''"
           target="_blank"
           rel="noopener">
            <span *iCms="'buttonCopy' of content"></span>
        </a>
        }
    </div>
    }
</div>
